/* src/app/register/register.component.css */
.screenPos {
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .screenPos {
    margin-top: -25%;
  }
}
.cardPos {
  width: 100rem;
  margin-bottom: 10%;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .cardPos {
    width: 100rem;
    margin-top: 5rem;
  }
}
.theSpace {
  margin-bottom: 30px;
}
.mobilePos {
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .mobilePos {
    margin-top: 42rem;
    padding-top: 10px;
    margin-bottom: 2rem;
  }
}
.hero__play {
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: rgba(94, 206, 66, 0.8);
  width: 9.4rem;
  height: 9.4rem;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 7rem;
  margin-top: 2rem;
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .hero__play {
    top: 11.8rem;
    margin-top: -3rem;
    transform: translateX(-50%);
    width: 6rem;
    height: 6rem;
  }
}
.hero__play img {
  max-width: 1rem;
}
.modalSize {
}
@media (max-width: 767px), screen and (max-width: 812px) and (orientation: landscape) {
  .modalSize {
  }
}
.link {
  color: #0000FF;
}
::ng-deep .popover-body {
  font-size: small;
}
/*# sourceMappingURL=register.component.css.map */
